export const connectorTokens: Record<string, string> = {
  'nav.tokens': 'API Tokens',
  'tok.title': 'API Tokens',
  'tok.token': 'Token',
  'tok.type': 'Loại',
  'tok.expires': 'Hết hạn',
  'tok.checked': 'Kiểm tra lúc',
  'tok.invalid': 'HỎNG / HẾT HẠN',
  'tok.neverExpires': 'Không hết hạn',
  'tok.daysLeft': 'Còn {n} ngày',
  'tok.pasteShort': 'Dán token NGẮN HẠN mới để gia hạn',
  'tok.shortHint': 'Lấy từ Graph API Explorer (developers.facebook.com/tools/explorer) với app "Report", scope ads_read. Hệ thống tự đổi thành token dài hạn ~60 ngày và cài đặt.',
  'tok.exchangeInstall': 'Đổi & cài đặt',
  'tok.updating': 'Đang đổi…',
  'tok.updated': 'Đã cài token — hết hạn {exp}. Data FB tự chạy lại theo cron hàng giờ.',
  'tok.refillNote': 'Lấp data thiếu: cron hàng giờ tự chạy lại khi token sống; refill cả tháng chạy ngày 1. Không cần thao tác thêm.',
  'tok.googleTitle': 'Tài khoản Google AdMob sync (refresh tokens)',
  'tok.googleAllOk': 'Tất cả sống',
  'tok.googleDead': '{n} CHẾT',
  'tok.googleNote': 'Kiểm tra sức khỏe read-only (probe thật từng account). Account chết = sync doanh thu AdMob của nó dừng âm thầm — gia hạn cần re-authorize tài khoản Google đó (OAuth consent) rồi cập nhật entry trong credentials.json.',
}
